export const AddonsDetailsDataHooks = {
  GROUP_NAME: 'addons-group-name',
  ADDON_CARD: 'addon-card',
  ADDON_NAME: 'addon-name',
  ADDON_PRICE: 'addon-price',
  ADDON_IMAGE: 'addon-image',
  ADDON_DURATION: 'addon-duration',
  ADDON_QUANTITY: 'addon-quantity',
  ADDON_CHECKBOX: 'addon-checkbox',
  ADDON_ADD_BUTTON: 'addon-add-button',
  ADDON_ADDED_CHIP: 'addon-added-chip',
  ADDON_DISABLED_REASON: 'addon-disabled-reason',
  GROUP_PROMPT: 'group-prompt',
} as const;
